export default {
     // 尝试开发table()
        jump(e, row, uptype, downtype, type, types) {
            
            // 回车键特殊字段
            if (e.$event.keyCode == '13' || e.$event.keyCode == '9') {
                if (type) {
                    this.$refs.dtlTable.setActiveCell(row, types);
                }
            }
            if (e.$event.keyCode == '39') {
                this.$refs.dtlTable.setActiveCell(row, downtype);
            }
            if (e.$event.keyCode == '37') {
                this.$refs.dtlTable.setActiveCell(row, uptype);
                // this.$refs.dtlTable.setActiveCell(row, 'qty');
            }
        },
}
